import catalogServer from "../../server/catalog";
import vitalSignServer from "../../server/vitalSign";
import nutritionalJournalItemServer from "../../server/nutritionalJournalItem";

const clientModule = {
  namespaced: true,
  state: () => ({
    refreshListeners: {
      fetchClient: {},
      fetchClientAlertNotes: {},
      fetchDocumentMenus: {},
      fetchEoc: {}
    },
    levelsOfCare: [],
    locations: [],
    genders: [],
    pronouns: [],
    maritalStatuses: [],
    states: [],
    allergyTypes: [],
    allergySeverities: [],
    relationships: [],
    vitalSigns: [],
    caseRoles: [],
    diagnosisCodeStatuses: [],
    nutritionalJournalItems: [],
    nutritionCategories: [],
    nutritionMeals: [],
    allergens: [],
    reactions: [],
    reviewTypes: [],
    utilizationStatuses: [],
    insuranceCoverages: [],
    medicationRoutes: [],
    measurements: [],
    taxonomyTypes: [],
    taxonomySpecialties: [],
    entityTypes: [],
    payerTypes: [],
    scheduleEventStatuses: [],
    races: [],
    ethnicities: [],
    languages: [],
    predefinedProtocols: [],
    placesOfService: [],
    sharePackages: [],
    dischargeReasons: []
  }),
  mutations: {
    setLevelsOfCare(state, levelsOfCare) {
      state.levelsOfCare = levelsOfCare;
    },
    setLocations(state, locations) {
      state.locations = locations;
    },
    setGenders(state, genders) {
      state.genders = genders;
    },
    setPronouns(state, pronouns) {
      state.pronouns = pronouns;
    },
    setMaritalStatuses(state, maritalStatuses) {
      state.maritalStatuses = maritalStatuses;
    },
    setStates(state, states) {
      state.states = states;
    },
    setAllergyTypes(state, allergyTypes) {
      state.allergyTypes = allergyTypes;
    },
    setAllergySeverities(state, allergySeverities) {
      state.allergySeverities = allergySeverities;
    },
    setRelationships(state, relationships) {
      state.relationships = relationships;
    },
    setVitalSigns(state, vitalSigns) {
      state.vitalSigns = vitalSigns;
    },
    setCaseRoles(state, caseRoles) {
      state.caseRoles = caseRoles;
    },
    setDischargeReasons(state, dischargeReasons) {
      state.dischargeReasons = dischargeReasons;
    },
    setdiagnosisCodeStatuses(state, diagnosisCodeStatuses) {
      state.diagnosisCodeStatuses = diagnosisCodeStatuses;
    },
    setNutritionalJournalItems(state, nutritionalJournalItems) {
      state.nutritionalJournalItems = nutritionalJournalItems;
    },
    setNutritionCategories(state, nutritionCategories) {
      state.nutritionCategories = nutritionCategories;
    },
    setNutritionMeals(state, nutritionMeals) {
      state.nutritionMeals = nutritionMeals;
    },
    setAllergens(state, allergens) {
      state.allergens = allergens;
    },
    setReactions(state, reactions) {
      state.reactions = reactions;
    },
    setReviewTypes(state, reviewTypes) {
      state.reviewTypes = reviewTypes;
    },
    setUtilizationStatuses(state, statuses) {
      state.utilizationStatuses = statuses;
    },
    setInsuranceCoverages(state, insuranceCoverages) {
      state.insuranceCoverages = insuranceCoverages;
    },
    setMedicationRoutes(state, medicationRoutes) {
      state.medicationRoutes = medicationRoutes;
    },
    setMeasurements(state, measurements) {
      state.measurements = measurements;
    },
    setTaxonomyTypes(state, taxonomyTypes) {
      state.taxonomyTypes = taxonomyTypes;
    },
    setTaxonomySpecialties(state, taxonomySpecialties) {
      state.taxonomySpecialties = taxonomySpecialties;
    },
    setEntityTypes(state, entityTypes) {
      state.entityTypes = entityTypes;
    },
    setPayerTypes(state, payerTypes) {
      state.payerTypes = payerTypes;
    },
    setScheduleEventStatuses(state, scheduleEventStatuses) {
      state.scheduleEventStatuses = scheduleEventStatuses;
    },
    setRaces(state, races) {
      state.races = races;
    },
    setEthnicities(state, ethnicities) {
      state.ethnicities = ethnicities;
    },
    setPredefinedProtocols(state, predefinedProtocols) {
      state.predefinedProtocols = predefinedProtocols;
    },
    setLanguages(state, languages) {
      state.languages = languages;
    },
    setPlacesOfService(state, placesOfService) {
      state.placesOfService = placesOfService;
    },
    setSharePackages(state, sharePackages) {
      for (let sharePackage of sharePackages) {
        sharePackage.forms.sort((a, b) => a.order - b.order);
        sharePackage.recurrentForms.sort((a, b) => a.order - b.order);
      }
      state.sharePackages = sharePackages;
    },
    dispatchListener(state, {listener, param}) {
      const newListener = {...state.refreshListeners[listener]};
      newListener[param] = +new Date();
      state.refreshListeners[listener] = newListener;
    }
  },
  actions: {
    async fetchLevelsOfCare(context, orderBy = null) {
      const levelsOfCare = await catalogServer.getLevelsOfCare(orderBy);
      context.commit("setLevelsOfCare", levelsOfCare);
    },
    async fetchLocations(context) {
      const locations = await catalogServer.getLocations();
      context.commit("setLocations", locations);
    },
    async fetchGenders(context) {
      const genders = await catalogServer.getGenders();
      context.commit("setGenders", genders);
    },
    async fetchPronouns(context) {
      const pronouns = await catalogServer.getPronouns();
      context.commit("setPronouns", pronouns);
    },
    async fetchMaritalStatuses(context) {
      const maritalStatuses = await catalogServer.getMaritalStatuses();
      context.commit("setMaritalStatuses", maritalStatuses);
    },
    async fetchStates(context) {
      const states = await catalogServer.getStates();
      context.commit("setStates", states);
    },
    async fetchAllergyTypes(context) {
      const allergyTypes = await catalogServer.getAllergyTypes();
      context.commit("setAllergyTypes", allergyTypes);
    },
    async fetchAllergySeverities(context) {
      const allergySeverities = await catalogServer.getAllergySeverities();
      context.commit("setAllergySeverities", allergySeverities);
    },
    async fetchRelationships(context) {
      const relationships = await catalogServer.getRelationships();
      context.commit("setRelationships", relationships);
    },
    async fetchVitalSigns(context) {
      const vitalSigns = await vitalSignServer.query();
      context.commit("setVitalSigns", vitalSigns);
    },
    async fetchCaseRoles(context) {
      const caseRoles = await catalogServer.getCaseRoles();
      context.commit("setCaseRoles", caseRoles);
    },
    async fetchDischargeReasons(context) {
      const dischargeReasons = await catalogServer.getDischargeReasons();
      context.commit("setDischargeReasons", dischargeReasons);
    },
    async fetchDiagnosisCodeStatuses(context) {
      const diagnosisCodeStatuses = await catalogServer.getDiagnosisCodeStatuses();
      context.commit("setdiagnosisCodeStatuses", diagnosisCodeStatuses);
    },
    async fetchNutritionalJournalItems(context) {
      const nutritionalJournalItems = await nutritionalJournalItemServer.query();
      context.commit("setNutritionalJournalItems", nutritionalJournalItems);
    },
    async fetchNutritionCategories(context) {
      const nutritionCategories = await catalogServer.getNutritionCategories();
      context.commit("setNutritionCategories", nutritionCategories);
    },
    async fetchNutritionMeals(context) {
      const nutritionMeals = await catalogServer.getNutritionMeals();
      context.commit("setNutritionMeals", nutritionMeals);
    },
    async fetchAllergens(context) {
      const allergens = await catalogServer.getAllergens();
      context.commit("setAllergens", allergens);
    },
    async fetchReactions(context) {
      const reactions = await catalogServer.getReactions();
      context.commit("setReactions", reactions);
    },
    async fetchReviewTypes(context) {
      const reviewTypes = await catalogServer.getReviewTypes();
      context.commit("setReviewTypes", reviewTypes);
    },
    async fetchUtilizationStatuses(context) {
      const statuses = await catalogServer.getUtilizationStatuses();
      context.commit("setUtilizationStatuses", statuses);
    },
    async fetchInsuranceCoverages(context) {
      const insuranceCoverages = await catalogServer.getInsuranceCoverages();
      context.commit("setInsuranceCoverages", insuranceCoverages);
    },
    async fetchMedicationRoutes(context) {
      const medicationRoutes = await catalogServer.getMedicationRoutes();
      context.commit("setMedicationRoutes", medicationRoutes);
    },
    async fetchMeasurements(context) {
      const measurements = await catalogServer.getMeasurements();
      context.commit("setMeasurements", measurements);
    },
    async fetchTaxonomyTypes(context) {
      const taxonomyTypes = await catalogServer.getTaxonomyTypes();
      context.commit("setTaxonomyTypes", taxonomyTypes);
    },
    async fetchTaxonomySpecialties(context) {
      const taxonomySpecialties = await catalogServer.getTaxonomySpecialties();
      context.commit("setTaxonomySpecialties", taxonomySpecialties);
    },
    async fetchEntityTypes(context) {
      const entityTypes = await catalogServer.getEntityTypes();
      context.commit("setEntityTypes", entityTypes);
    },
    async fetchPayerTypes(context) {
      const payerTypes = await catalogServer.getPayerTypes();
      context.commit("setPayerTypes", payerTypes);
    },
    async fetchScheduleEventStatuses(context) {
      const scheduleEventStatuses = await catalogServer.getScheduleEventStatuses();
      context.commit("setScheduleEventStatuses", scheduleEventStatuses);
    },
    async fetchInsuranceCompanies() {
    },
    async fetchRaces(context) {
      const races = await catalogServer.getRaces();
      context.commit("setRaces", races);
    },
    async fetchEthnicities(context) {
      const ethnicities = await catalogServer.getEthnicities();
      context.commit("setEthnicities", ethnicities);
    },
    async fetchLanguages(context) {
      const languages = await catalogServer.getLanguages();
      context.commit("setLanguages", languages);
    },
    async fetchPredefinedProtocols(context) {
      const predefinedProtocols = await catalogServer.getPredefinedProtocols();
      context.commit("setPredefinedProtocols", predefinedProtocols);
    },
    async fetchPlacesOfService(context) {
      const placesOfService = await catalogServer.getPlacesOfService();
      context.commit("setPlacesOfService", placesOfService);
    },
    async fetchSharePackages(context) {
      const sharePackages = await catalogServer.getSharePackages();
      context.commit("setSharePackages", sharePackages);
    }
  },
  getters: {
    listeners(state) {
      return state.refreshListeners;
    },
    vitalSignsCurrentLocation: (state, getters, rootState) => {
      const location = rootState.layout.selectedLocationObj;
      if (location) {
        return state.vitalSigns.filter(vitalSign =>
          location.vitalSignIds.includes(vitalSign.id)
        );
      }
      return [];
    },
    levelsOfCareCurrentLocation: (state, getters, rootState) => {
      const location = rootState.layout.selectedLocationObj;
      if (location) {
        return state.levelsOfCare.filter(levelOfCare =>
          location.serviceIds.includes(levelOfCare.id)
        );
      }
      return state.levelsOfCare;
    },
    formsCurrentLocation: (state, getters, rootState) => {
      const location = rootState.layout.selectedLocationObj;
      let mainDocs = rootState.formBuilder.list["main"];
      let roiDocs = rootState.formBuilder.list["releaseOfInformation"];
      if (location) {
        mainDocs = [...mainDocs].filter(form =>
          location.formIds.includes(form.id)
        );
        roiDocs = roiDocs.filter(form => location.formIds.includes(form.id));
        return [...mainDocs, ...roiDocs];
      }
      return [...mainDocs, ...roiDocs];
    },
    formsMainAndMasterTreatmentPlanCurrentLocation: (
      state,
      getters,
      rootState
    ) => {
      const location = rootState.layout.selectedLocationObj;
      if (location) {
        return [
          ...rootState.formBuilder.list["main"],
          ...rootState.formBuilder.list["masterTreatmentPlan"]
        ].filter(form => location.formIds.includes(form.id));
      }
      return [
        ...rootState.formBuilder.list["main"],
        ...rootState.formBuilder.list["masterTreatmentPlan"]
      ];
    },
    formGroupsCurrentLocation: (state, getters, rootState) => {
      const location = rootState.layout.selectedLocationObj;
      if (location) {
        return rootState.formGroup.list.filter(formGoup =>
          location.formGroupIds.includes(formGoup.id)
        );
      }
      return rootState.formGroup.list;
    },
    selectedLocation: (state, getters, rootState) => {
      const location = rootState.layout.selectedLocationObj;
      return location;
    },
    lowerOperationsStarts(state) {
      const allOperationsStarts = state.locations
        .filter(
          location =>
            location.operationStarts &&
            typeof location.operationStarts === "string"
        )
        .map(location => {
          const [hours, minutes] = location.operationStarts
            .split(":")
            .map(Number);
          return {hours: hours, minutes: minutes};
        });

      const lowerTime = allOperationsStarts.reduce((acc, curr) => {
        const accTime = acc.hours * 60 + acc.minutes;
        const currTime = curr.hours * 60 + curr.minutes;
        return accTime < currTime ? acc : curr;
      });

      const formattedHours = String(lowerTime.hours).padStart(2, "0");
      const formattedMinutes = String(lowerTime.minutes).padStart(2, "0");

      return `${formattedHours}:${formattedMinutes}`;
    },
    higherOperationsEnds(state) {
      const allOperationsEnds = state.locations
        .filter(
          location =>
            location.operationStarts &&
            typeof location.operationStarts === "string"
        )
        .map(location => {
          const [hours, minutes] = location.operationEnds
            .split(":")
            .map(Number);
          return {hours: hours, minutes: minutes};
        });

      const higherTime = allOperationsEnds.reduce((acc, curr) => {
        const accTime = acc.hours * 60 + acc.minutes;
        const currTime = curr.hours * 60 + curr.minutes;
        return accTime > currTime ? acc : curr;
      });

      const formattedHours = String(higherTime.hours).padStart(2, "0");
      const formattedMinutes = String(higherTime.minutes).padStart(2, "0");

      return `${formattedHours}:${formattedMinutes}`;
    }
  }
};

export default clientModule;
